import { put, call, takeEvery, all } from "redux-saga/effects";
import * as purchaseOrderActions from "./action";
import api from "../../client/utils/clientApiHelper";
import {
  GET_POOL_GRID_DATA,
  GET_PURCHASE_TYPE_DROPDOWN,
  GET_REGISTERED_DROPDOWN,
  GET_ORDER_TYPE_DROPDOWN,
  GET_CLIENT_CODE_DROPDOWN,
  GET_ASSIGNTO_DROPDOWN,
  GET_CAPEX_DROPDOWN,
  GET_CHANGE_LOGS,
  UPDATE_REASON_CODE,
  GET_PO_EQ_CLASS_CODE_DROPDOWN,
} from "./types";
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { isOrderAttachmentSaved, setReasonCodeResponse } from "Store/Component/FleetManagement/FleetManagementAction";
import { API_URL, apiMethod, apiType } from "utils";
import { IPayload } from "Model/IPayload";
import { SAVE_ORDER_ATTACHMENTS } from "Store/Component/FleetManagement/FleetManagementType";
import FleetManagementApiService from "Service/FleetManagement/FleetManagementApiService";

const errorForSavePurchaseOrder = {
  showAlert: true,
  type: "error",
  text: "Something went wrong, Please try again !!",
};

const successForCompletePurchaseOrder = {
  showAlert: true,
  type: "success",
  text: "Purchase order has been completed",
};

function* getPoolGridData(req: any): any {
  try {
    yield put(globalLoaderText("Getting pool asset...."));
    let payloadData : IPayload = {
      apiType : apiType.FleetManagement,
      endpoint : `fleet/asset/cippool/${req?.subTypeId}`,
      apiMethod :  apiMethod.GET,
      payload : null
      
     }
    const response = yield call(api.callFleetPost, API_URL.PostWebApp,payloadData );
    if(response){
      yield put(purchaseOrderActions.setPoolGridData(response));
      yield put(globalLoaderText(""));
    } else {
      yield put(purchaseOrderActions.setPoolGridData([]));
      yield put(globalLoaderText(""));
    }
  } catch (error) {
    yield put(purchaseOrderActions.setPoolGridData([]));
    yield put(globalLoaderText(""));
  }
}

function* getPurchaseTypeDropdown(): any {
  try {
    const response = [
      { value: "Capital Lease", text: "Capital Lease" },
      { value: "Operating Lease", text: "Operating Lease" },
      { value: "Purchase", text: "Purchase" },
    ];
    const defaultPurchaseTypeDropdownOption: any = {
      text: "Select",
      value: null,
    };
    response.unshift(defaultPurchaseTypeDropdownOption);
    yield put(purchaseOrderActions.setPurchaseTypeDropdown(response));
  } catch (error) {
    yield put(purchaseOrderActions.setPurchaseTypeDropdown([]));
  }
}
function* getRegisteredDropdown(): any {
  try {
    const response = [
      { value: true, text: "Yes" },
      { value: false, text: "No" },
    ];
    const defaultRegisteredOption: any = {
      text: "Select",
      value: null,
    };
    response.unshift(defaultRegisteredOption);
    yield put(purchaseOrderActions.setRegisteredDropdown(response));
  } catch (error) {
    yield put(purchaseOrderActions.setRegisteredDropdown([]));
  }
}
function* getOrderTypeDropdown(): any {
  try {
    let payloadData : IPayload = {
      apiType : apiType.FleetManagement,
      endpoint : `fleet/ordertypes`,
      apiMethod : apiMethod.GET,
      payload : null
      
    }  
    const response = yield call(
      api.callFleetPost,API_URL.PostWebApp,payloadData
     
    );
    yield put(purchaseOrderActions.setOrderTypeDropdown(response));
  } catch (error) {
    yield put(purchaseOrderActions.setOrderTypeDropdown([]));
  }
}
function* getClientCodeDropdown(): any {
  try {
    let payloadData : IPayload = {
      apiType : apiType.FleetManagement,
      endpoint : `fleet/clientcodes`,
      apiMethod : apiMethod.GET,
      payload : null
     
    }
    const response = yield call(
      api.callFleetPost, API_URL.PostWebApp,payloadData
     
    );
    yield put(purchaseOrderActions.setClientCodeDropdown(response));
  } catch (error) {
    yield put(purchaseOrderActions.setClientCodeDropdown([]));
  }
}
function* getCapexDropdown(): any {
  try {
    const response = [
      { value: "Vehicle Request", text: "Vehicle Request" },
      { value: "Managed Equipment", text: "Managed Equipment" },
      { value: "Non-Standard Equipment", text: "Non-Standard Equipment" },
    ];
    const defaultOrderTypeOption: any = {
      text: "N/A",
      value: null,
    };
    response.unshift(defaultOrderTypeOption);
    yield put(purchaseOrderActions.setCapexDropdown(response));
  } catch (error) {
    yield put(purchaseOrderActions.setCapexDropdown([]));
  }
}
function* getAssignToDropdown(): any {
  try {
    let payloadData : IPayload = {
      apiType : apiType.FleetManagement,
      endpoint : `fleet/dropdown/fleetprocessor`,
      apiMethod :  apiMethod.GET,
      payload : null
      
  }
    const response = yield call(
      api.callFleetPost,API_URL.PostWebApp,payloadData
      
    );
    yield put(purchaseOrderActions.setAssignToDropdown(response));
  } catch (error) {
    yield put(purchaseOrderActions.setAssignToDropdown([]));
  }
}

function* getChangeLogs(req: any): any {
  try {
    let payloadData : IPayload = {
      apiType : apiType.FleetManagement,
      endpoint : `fleet/changelogs/${req.payload}`,
      apiMethod :  apiMethod.GET,
      payload : null
      
     }
    const response = yield call(
      api.callFleetPost,API_URL.PostWebApp,payloadData
      
    );
    if (response?.length) {
      const result = {
        [req.payload]: response,
      };
      yield put(purchaseOrderActions.setChangeLogs(result));
    } else {
      yield put(purchaseOrderActions.setChangeLogs([]));
    }
  } catch (error: any) {
    yield put(purchaseOrderActions.setChangeLogs([]));
  }
}

function* updateReasonCode(req: any): any {
  try {
    yield put(globalLoaderText("Saving Reason Code..."));
    let payloadData : IPayload = {
      apiType : apiType.FleetManagement,
      endpoint : `fleet/update/reasoncode`,
      apiMethod :  apiMethod.POST,
      payload : req.payload  
     }
    const response = yield call(
      api.callFleetPost, API_URL.PostWebApp, payloadData    
    );
    if (response) {
      yield put(globalLoaderText(""));
      yield put(setReasonCodeResponse(response));
      yield put(
        purchaseOrderActions.setError({
          ...successForCompletePurchaseOrder,
          text: "Reason code has been saved" ,
          fleetDetailId: req?.payload?.fleetDetailId
        })
      );

    } else {
      yield put(globalLoaderText(""));
      yield put(
        purchaseOrderActions.setError({
          ...errorForSavePurchaseOrder,
          fleetDetailId: req?.payload?.fleetDetailId
        })
      );
    }
  } catch (error: any) {
    yield put(globalLoaderText(""));
    yield put(
      purchaseOrderActions.setError({
        ...errorForSavePurchaseOrder,
        fleetDetailId: req?.payload?.fleetDetailId
      })
    );
  }
}

function* getEqClassCodeDropdown(): any {
  try {
    let payloadData: IPayload = {
      apiType: apiType.AssetManagement,
      endpoint: `assets/dropdown/eqclasscode`,
      apiMethod: apiMethod.GET,
      payload: null,
    };

    const response = yield call(
      api.callAssetPost,
      API_URL.PostWebApp,
      payloadData
    );

    const options = (response || []).map((item: any) => ({
      label: `${item.value} - ${item.text}`,
      value: item.value,
      description: item.text,
    }));
    yield put(purchaseOrderActions.setEqClassCodeDropdown(options));
  } catch (error) {
    yield put(purchaseOrderActions.setEqClassCodeDropdown([]));
  }
}

function* saveOrderAttachmentsList(req: any): any {
  try {
      yield put(globalLoaderText("Saving Attachements...."));
      let payloadData: IPayload = {
          apiType: apiType.FleetManagement,
          endpoint: `fleet/order/attachments`,
          apiMethod: apiMethod.POST,
          payload: req.payload
      }
      const response = yield call(
          FleetManagementApiService.post, API_URL.PostWebApp, payloadData
      );
      yield put(isOrderAttachmentSaved(response))
      yield put(globalLoaderText(""));
  } catch (error) {
      yield put(isOrderAttachmentSaved(false))
      yield put(globalLoaderText(""));
  }
}

function* pendingOrderSagaWatcher() {
  yield takeEvery(GET_POOL_GRID_DATA, getPoolGridData);
  yield takeEvery(GET_PURCHASE_TYPE_DROPDOWN, getPurchaseTypeDropdown);
  yield takeEvery(GET_REGISTERED_DROPDOWN, getRegisteredDropdown);
  yield takeEvery(GET_ORDER_TYPE_DROPDOWN, getOrderTypeDropdown);
  yield takeEvery(GET_CLIENT_CODE_DROPDOWN, getClientCodeDropdown);
  yield takeEvery(GET_CAPEX_DROPDOWN, getCapexDropdown);
  yield takeEvery(GET_ASSIGNTO_DROPDOWN, getAssignToDropdown);
  yield takeEvery(GET_CHANGE_LOGS, getChangeLogs);
  yield takeEvery(UPDATE_REASON_CODE, updateReasonCode)
  yield takeEvery(SAVE_ORDER_ATTACHMENTS, saveOrderAttachmentsList)
  yield takeEvery(GET_PO_EQ_CLASS_CODE_DROPDOWN, getEqClassCodeDropdown);
}

export default function* combinedSaga() {
  yield all([pendingOrderSagaWatcher()]);
}
